import { Box, Link } from "@shopify/polaris";
import ShopifyModal from "../../../../components/ShopifyModal";
import React from 'react';
// import {
//     PlayCircleIcon
//   } from '@shopify/polaris-icons';
const Index = ({open,setOpen})=> {
    return (
        <Box>
            <ShopifyModal id="import-ali-modal" open={open} heading="Import products from AliExpress" 
            onClose={()=>{setOpen(false)}}
            primaryAction={{content: 'Install Google Extension to Import Product', onAction: ()=>{
                window.open("https://chromewebstore.google.com/detail/dropshipman-aliexpress-pr/bobhjedlciclpchpelkgiojkmmfgnihg", "_blank");
            }}}
            // secondaryActions={[{
            //     content: "Watch video tutorial",
            //     onAction: ()=>{
                    
            //     },
            //     icon: PlayCircleIcon
            // }]}
            >
                <Box className="import_ali_modal_content">
                Importing AliExpress products requires the installation of the Dropshipman Google Extension. Please follow these steps:
                <p>1. Download and install the&nbsp;<Link url="https://chromewebstore.google.com/detail/dropshipman-aliexpress-pr/bobhjedlciclpchpelkgiojkmmfgnihg" external>Dropshipman Google Extension.</Link></p>
                <p>2. Log in to the Dropshipman Google Extension using your Dropshipman account.</p>
                <p>3. Visit the AliExpress product details page, and click the "Add to my product list" button to collect the product. &nbsp;<Link url="https://www.aliexpress.com/" external>https://www.aliexpress.com/</Link>.</p>
                <p>4. View imported products in Product Center.</p>
                </Box>
            </ShopifyModal>
        </Box>
    );
}

export default Index;
